import Grid from '@material-ui/core/Grid';
import React, { PureComponent } from 'react';
import { LabeledColumn, LabeledColumnProps } from '../TextGroup/LabeledColumn';
import { ArrowColumn } from './ArrowColumn';

interface OwnProps {
  from: LabeledColumnProps;
  stops?: number;
  stopCityCodes?: string[];
  to: LabeledColumnProps;
  type: 'Air' | 'Hotel' | 'Car';
}

export class Route extends PureComponent<OwnProps> {
  public render() {
    const { from, to, stops, stopCityCodes, type } = this.props;
    return (
      <Grid container spacing={8} wrap="nowrap">
        <LabeledColumn {...from} xs={4} />
        <ArrowColumn
          stops={stops}
          stopCityCodes={stopCityCodes}
          type={type}
          xs={4}
        />
        <LabeledColumn {...to} xs={4} />
      </Grid>
    );
  }
}
